import * as React from "react";
import classnames from "classnames";
import CardActions from "../components/Card/components/CardActions.js";
import CardButton from "../components/Card/components/CardButton.js";
import CardButtonLayout from "../components/Card/components/CardButtonLayout.js";
import CardContent from "../components/Card/components/CardContent.js";
import CardHeading from "../components/Card/components/CardHeading.js";
import CardIcon from "../components/Card/components/CardIcon.js";
import CardImage from "../components/Card/components/CardImage.js";
import CardLink from "../components/Card/components/CardLink.js";
import CardSection from "../components/Card/components/CardSection.js";
import CardText from "../components/Card/components/CardText.js";
import CardWrapper from "../components/Card/components/CardWrapper.js";
/* empty css          */
const Wrapper = (props) => "href" in props ? /* @__PURE__ */ React.createElement("a", { ...props }, props.children) : /* @__PURE__ */ React.createElement("div", { ...props });
const Card = ({
  layout = "vertical",
  children,
  className,
  ...rest
}) => {
  const isLink = "href" in rest;
  return /* @__PURE__ */ React.createElement(
    Wrapper,
    {
      className: classnames("card-base", `card-base--${layout}`, className, {
        "card-base--with-link": isLink
      }),
      ...rest
    },
    React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return child;
      if (child.type === CardImage) {
        return /* @__PURE__ */ React.createElement(
          CardImage,
          {
            ...child.props,
            className: classnames(child.props.className, "card-base__image")
          }
        );
      }
      if (isLink && child.type === CardContent) {
        return /* @__PURE__ */ React.createElement(CardContent, { ...child.props, variant: "link" });
      }
      return child;
    })
  );
};
Card.Actions = CardActions;
Card.Button = CardButton;
Card.ButtonLayout = CardButtonLayout;
Card.Content = CardContent;
Card.Heading = CardHeading;
Card.Icon = CardIcon;
Card.Image = CardImage;
Card.Link = CardLink;
Card.Section = CardSection;
Card.Text = CardText;
Card.OldCard = CardWrapper;
export {
  Card as default
};
//# sourceMappingURL=Card.js.map
